<template>
  <div class="team-introduction">
    <ucar-title>{{title}}</ucar-title>
    <ucar-img-header type="team-index"></ucar-img-header>
    <div class="introduction-advantage">
      <h3>加入优势</h3>
      <ul>
        <li :key="item.label" v-for="item in advantageList">
          <strong>{{item.label}}</strong>
          {{item.des}}
        </li>
      </ul>
    </div>
    <introduction-require title="车队/企业要求" :list="teamRequire"></introduction-require>
    <introduction-require title="司机要求" :list="driverRequire"></introduction-require>
    <introduction-require title="车辆要求" :list="carRequire"></introduction-require>
    <introduction-process title="招募流程" :list="process"></introduction-process>
    <div class="introduction-footer">
      <ucar-button @click="goLogin">立即报名</ucar-button>
      <ucar-button @click="goLogin">查看报名进度</ucar-button>
    </div>
  </div>
</template>

<script>
import { loginStatus } from '../../utils/constants'
import introductionRequire from '../../components/introduction-require'
import introductionProcess from '../../components/introduction-process'

export default {
  data () {
    return {
      title: '神州专车车队招募',
      advantageList: [
        {
          label: '大平台',
          des: '上市企业，行业标杆，高端用户，全国加盟，全方位运营支持。'
        },
        {
          label: '高佣金',
          des: '固定提成+浮动提成+阶段性任务激励。'
        },
        {
          label: '有车无车均可合作',
          des: '低成本投入，平台提供多款车辆供司机租赁/购买，企业同时可获得高收益回报。'
        }
      ],
      teamRequire: [
        '经营范围包括汽车租赁服务、租车服务、咨询服务等；',
        '注册资金不少于200W，注册时长半年以上；',
        '合作规模：20人及以上合作司机，20台及以上合作车辆（公司可提供车辆供司机租赁/购买）；',
        '需要有固定的经营场所；',
        '具有丰富的车队及驾驶员管理经验。'
      ],
      driverRequire: [
        '符合当地网约车标准；',
        '驾驶技术：持有C1及以上驾照，3年及以上驾龄，且熟悉本地路况；',
        '形象：男25-55周岁，女25-50周岁，身体健康，品貌端正；',
        '素质：诚信正直，有服务意识；',
        '无重大交通事故、无犯罪记录。'
      ],
      carRequire: [
        '符合当地网约车标准；',
        '车辆要求15万以上B级轿车；',
        '车龄5年以下；',
        '车辆为本地牌照；',
        '未发生过重大交通事故、未泡过水。'
      ],
      process: [
        '申请留资',
        '意向沟通',
        '资质审核',
        '合同签订',
        '账号开通',
        '运营合作'
      ]
    }
  },
  components: {
    introductionRequire,
    introductionProcess
  },
  methods: {
    goLogin () {
      if (this.loginStatus === loginStatus.fillInfo) {
        this.$router.push('/team-info')
      } else {
        this.$router.push(`/login?regType=6`)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "../../styles/variable.styl";

.team-introduction {
  .introduction-advantage {
    margin-bottom: 20px;
    padding: 40px 60px;
    line-height: 1;
    background-color: #fff;
    color: $ucar_font_color;

    h3 {
      margin-bottom: 30px;
      text-align: center;
      font-size: $ucar_font_h4;
      font-weight: bold;
    }

    ul {
      padding-left: 15px;

      li {
        list-style: disc;
        font-size: $ucar_font_h6;
        line-height: 1.5;
        margin-bottom: 15px;
      }
    }
  }
  .introduction-footer {
    display: flex;
    align-items: center;
    padding: 0 20px 20px;
  }
}
</style>
